import API from '@aws-amplify/api';

export default class MarketingPreferencesService {
  static get({ channel, address }) {
    return API.get(
      'MarketingPreferences',
      `/preferences?channel=${channel}&address=${encodeURIComponent(address)}`
    );
  }

  static post(channel, isEnabled, address, source) {
    return API.post('MarketingPreferences', `/preferences`, {
      body: {
        channel,
        status: isEnabled ? 'ENABLED' : 'DISABLED',
        address,
        source,
      },
    });
  }
}
